import React from 'react'
import { Grid, Link, Pagination, Typography } from '@mui/material'
import { APP_BASE_URL } from '../../constants'

const ImageList = ({ list, needPagination, totalPages, pageNumber, handlePageChanged }) => {
	return (
		<>
			<Grid
				container
				color="white"
				sx={{ display: 'flex', flexDirection: 'row', m: (theme) => theme.spacing(3, 0) }}
			>
				{list.map(({ title, excerpt, image, type, slug }, index) => (
					<Grid
						item
						xs={12}
						md={4}
						key={index}
						sx={(theme) => ({
							flexDirection: 'column',
							m: (theme) => theme.spacing(4, 0),
							overflow: 'hidden',
							[theme.breakpoints.down('md')]: {
								'& img': {
									width: '100%',
								},
								'& p, & h6, & a': {
									m: 0,
									p: 0,
								},
								'& h6': {
									fontSize: 19,
									fontWeight: 800,
									mt: 2,
								},
								'& p': {
									fontSize: 16,
									fontWeight: 400,
									my: 2,
								},
								'& a': {
									fontSize: 16,
									fontWeight: 600,
								},
							},
						})}
					>
						{image && (
							<Typography
								component="div"
								sx={{ m: 2 }}
								dangerouslySetInnerHTML={{ __html: image }}
							/>
						)}
						<Typography
							component="h6"
							color="text.primary"
							sx={{
								display: 'block',
								fontSize: 18,
								fontWeight: 700,
								m: (theme) => theme.spacing(2, 0, 1),
								pr: 3,
								cursor: 'pointer',
								textAlign: 'left',
								pl: 2,
							}}
							dangerouslySetInnerHTML={{ __html: title }}
						/>
						<Typography
							component="div"
							color="text.publish"
							sx={{ fontSize: 14, fontWeight: 900, textAlign: 'left', pl: 2 }}
							dangerouslySetInnerHTML={{ __html: excerpt }}
						/>
						<Link
							color="secondary.main"
							href={`${APP_BASE_URL}${type}/${slug}`}
							sx={{
								fontSize: 12,
								fontWeight: 400,
								textAlign: 'left',
								display: 'block',
								pl: 2,
								m: (theme) => theme.spacing(2, 0),
								cursor: 'pointer',
							}}
						>
							lire la suite
						</Link>
					</Grid>
				))}
			</Grid>
			{needPagination && totalPages > 1 && (
				<Pagination
					count={totalPages}
					page={pageNumber || 1}
					onChange={handlePageChanged}
					sx={{
						display: 'flex',
						justifyContent: 'center',
						'& .MuiPagination-ul': {
							borderBottom: '2px solid black',
							pb: 2,

							'& .MuiButtonBase-root': {
								fontSize: 16,
								fontWeight: 600,

								'&.Mui-selected': {
									bgcolor: 'transparent',
									color: 'secondary.main',
									fontSize: 18,
									fontWeight: 900,
								},
							},
						},
					}}
				/>
			)}
		</>
	)
}

export default ImageList
